import React from 'react';
import backgroundImage   from '../img/carousel-1.jpg'
import def from 'ajv/dist/vocabularies/discriminator';

const PageHeader = ({ title, breadcrumbs }) => {
  const headerStyle = {
    background: `linear-gradient(rgba(0, 0, 0, .6), rgba(0, 0, 0, .6)), url(${backgroundImage}) center center no-repeat`,
    backgroundSize: 'cover'
  };

  return (
    <div className="container-fluid py-5" style={headerStyle}>
      <div className="container text-center py-5">
        <h1 className="display-2 text-white mb-4 animated slideInDown">{title}</h1>
        <nav aria-label="breadcrumb" className="animated slideInDown">
          <ol className="breadcrumb justify-content-center mb-0">
            {breadcrumbs.map((breadcrumb, index) => (
              <li
                key={index}
                className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? "active" : ""}`}
                aria-current={index === breadcrumbs.length - 1 ? "page" : undefined}
              >
                {breadcrumb.link ? <a href={breadcrumb.link}>{breadcrumb.label}</a> : breadcrumb.label}
              </li>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default PageHeader

